module.exports = __webpack_public_path__ + "ps.svg?b20ddc99ce78f3e6d0a175101690dbee";